// extracted by mini-css-extract-plugin
export default {"container":"footer_container__N9+lw","title":"footer_title__zlI1a","link":"footer_link__QmZEA","divider":"footer_divider__J8B5M","poweredBy":"footer_poweredBy__nhrgb"};